function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { getDefaultElementPosition, getElementPosition, isElementPositionContains, isElementPositionCross, isElementPositionEqual } from '@bydesign-ui/hooks';
import { getDefaultMousePos } from '../../drag';
import { Emitter } from '@bydesign-ui/hooks';
var KEY_FIELD_MAP = {
  alt: 'altKey',
  meta: 'metaKey',
  shift: 'shiftKey',
  ctrl: 'ctrlKey'
};
export var DragMask = function (_Emitter) {
  _inherits(DragMask, _Emitter);

  var _super = _createSuper(DragMask);

  function DragMask() {
    var _this;

    _classCallCheck(this, DragMask);

    _this = _super.apply(this, arguments);
    _this.boxRect = getDefaultElementPosition();
    _this.startPos = getDefaultMousePos();
    _this.endPos = getDefaultMousePos();
    _this.dragging = false;
    _this.maskRelativeRect = getDefaultElementPosition();
    _this.maskClientRect = getDefaultElementPosition();
    _this.overflow = false;
    _this.selectable = false;
    _this.draggingSelectable = false;
    _this.selectType = 'cover';
    _this.domKey = 'data-mask-key';
    _this.container = null;
    _this.negativeKeys = ['meta'];
    return _this;
  }

  _createClass(DragMask, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var _options$overflow = options.overflow,
          overflow = _options$overflow === void 0 ? false : _options$overflow,
          _options$selectable = options.selectable,
          selectable = _options$selectable === void 0 ? false : _options$selectable,
          _options$draggingSele = options.draggingSelectable,
          draggingSelectable = _options$draggingSele === void 0 ? false : _options$draggingSele,
          _options$selectType = options.selectType,
          selectType = _options$selectType === void 0 ? 'cover' : _options$selectType,
          _options$domKey = options.domKey,
          domKey = _options$domKey === void 0 ? 'data-mask-key' : _options$domKey,
          negativeKeys = options.negativeKeys;
      this.overflow = overflow;
      this.selectable = selectable;
      this.draggingSelectable = draggingSelectable;
      this.selectType = selectType;
      this.domKey = domKey;
      this.negativeKeys = negativeKeys || ['meta'];
    }
  }, {
    key: "updateContainer",
    value: function updateContainer(container) {
      this.container = container;
    }
  }, {
    key: "updateBoxRect",
    value: function updateBoxRect(rect) {
      this.boxRect = rect;
    }
  }, {
    key: "updateStartPos",
    value: function updateStartPos(e) {
      this.dragging = true;
      this.startPos = e.startMousePos;
      this.endPos = e.startMousePos;
      this.emitEvent('start', e);
    }
  }, {
    key: "updateEndPos",
    value: function updateEndPos(e) {
      this.endPos = e.currentMousePos;

      if (this.dragging) {
        this.emitEvent('change', e);
      }
    }
  }, {
    key: "stopDrag",
    value: function stopDrag(e) {
      this.dragging = false;
      this.endPos = e.currentMousePos;
      this.emitEvent('change', e);
      this.emitEvent('end', e);
      this.startPos = getDefaultMousePos();
      this.endPos = getDefaultMousePos();
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return this.dragging;
    }
  }, {
    key: "getRelativeRect",
    value: function getRelativeRect() {
      var rect = this.calcMaskRect();

      if (isElementPositionEqual(rect, this.maskRelativeRect)) {
        return this.maskRelativeRect;
      }

      return this.maskRelativeRect = rect;
    }
  }, {
    key: "getMaskClientRect",
    value: function getMaskClientRect() {
      var rect = this.calcRegionRect();

      if (isElementPositionEqual(rect, this.maskClientRect)) {
        return this.maskClientRect;
      }

      return this.maskClientRect = rect;
    }
  }, {
    key: "calcMaskRect",
    value: function calcMaskRect() {
      var _this$boxRect = this.boxRect,
          boxLeft = _this$boxRect.left,
          boxTop = _this$boxRect.top,
          boxRight = _this$boxRect.right,
          boxBottom = _this$boxRect.bottom,
          boxWidth = _this$boxRect.width,
          boxHeight = _this$boxRect.height;

      var _this$calcRegionRect = this.calcRegionRect(),
          regionLeft = _this$calcRegionRect.left,
          regionTop = _this$calcRegionRect.top,
          regionRight = _this$calcRegionRect.right,
          regionBottom = _this$calcRegionRect.bottom;

      var overflow = this.overflow;
      var left = overflow ? regionLeft - boxLeft : Math.max(regionLeft - boxLeft, 0);
      var top = overflow ? regionTop - boxTop : Math.max(regionTop - boxTop, 0);
      var right = overflow ? boxRight - regionRight : Math.max(boxRight - regionRight, 0);
      var bottom = overflow ? boxBottom - regionBottom : Math.max(boxBottom - regionBottom, 0);
      return {
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        width: boxWidth - left - right,
        height: boxHeight - top - bottom
      };
    }
  }, {
    key: "calcRegionRect",
    value: function calcRegionRect() {
      var _this$startPos = this.startPos,
          startClientX = _this$startPos.clientX,
          startClientY = _this$startPos.clientY;
      var _this$endPos = this.endPos,
          endClientX = _this$endPos.clientX,
          endClientY = _this$endPos.clientY;
      var left = Math.min(startClientX, endClientX);
      var top = Math.min(startClientY, endClientY);
      var width = Math.abs(startClientX - endClientX);
      var height = Math.abs(startClientY - endClientY);
      return {
        left: left,
        top: top,
        right: left + width,
        bottom: top + height,
        width: width,
        height: height
      };
    }
  }, {
    key: "emitEvent",
    value: function emitEvent(type, e) {
      var draggingSelectable = this.draggingSelectable,
          selectable = this.selectable;
      var negative = this.negativeKeys.every(function (key) {
        return e[KEY_FIELD_MAP[key]];
      });
      this.emit(type, _objectSpread(_objectSpread({}, e), {}, {
        dragging: this.dragging,
        rect: this.getRelativeRect(),
        clientRect: this.getMaskClientRect(),
        negative: negative,
        selected: type === 'change' && draggingSelectable || type === 'end' && selectable ? this.getSelectedKeys() : []
      }));
    }
  }, {
    key: "getSelectedKeys",
    value: function getSelectedKeys() {
      var container = this.container,
          domKey = this.domKey,
          selectType = this.selectType;
      var client = this.getMaskClientRect();

      if (container == null) {
        return [];
      }

      var elemList = [].slice.call(container.querySelectorAll('[' + domKey + ']'));
      var keys = {};
      elemList.forEach(function (elem) {
        var key = elem.getAttribute(domKey);

        if (key == null) {
          return;
        }

        if (selectType === 'cover' ? isElementPositionContains(client, getElementPosition(elem)) : isElementPositionCross(client, getElementPosition(elem))) {
          keys[key] = true;
        }
      });
      return Object.keys(keys);
    }
  }]);

  return DragMask;
}(Emitter);